import { atom } from "jotai";
import { entitlementsAtom_SUSPENDS } from "../account";

/**
 * Derived atom that determines whether Copilot is enabled for the current account.
 *
 * Returns true if:
 * - is_copilot_enabled is true
 *
 * Returns false if:
 * - Entitlements haven't loaded yet (null)
 * - is_copilot_enabled is false (enterprise opt-out)
 */
export const isCopilotEnabledAtom_SUSPENDS = atom(async (get) => {
  const entitlements = await get(entitlementsAtom_SUSPENDS);

  if (!entitlements) {
    return false; // Not enabled if we can't fetch entitlements
  }

  return entitlements.limits.is_copilot_enabled;
});

isCopilotEnabledAtom_SUSPENDS.debugLabel = "isCopilotEnabledAtom_SUSPENDS";
